<template>
	<deposit-redesign
		v-if="isProfileEnhancementEnabled"
		v-bind="$attrs"
		v-on="$listeners"
	/>
	<deposit-legacy
		v-else
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script>
import DepositLegacy from "./DepositLegacy.vue";
import DepositRedesign from "./DepositRedesign.vue";

export default {
	inheritAttrs: false,
	components: {
		DepositLegacy,
		DepositRedesign,
	},
};
</script>
